import { render } from "./UpdateBtn.vue?vue&type=template&id=0cf313d1"
import script from "./UpdateBtn.vue?vue&type=script&lang=js"
export * from "./UpdateBtn.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__